import { PackUnit } from '@/enums';

export enum PortionUnit {
  Cup = 'C',
  Each = 'EA',
  FluidOunce = 'FL OZ',
  Gallon = 'GAL',
  Gram = 'G',
  Liter = 'L',
  Milliliter = 'ML',
  Ounce = 'OZ',
  Pint = 'PT',
  Pound = 'LB',
  Quart = 'QT',
  Tablespoon = 'TBSP',
  Teaspoon = 'TSP',
}

export enum UnitType {
  Each = 'Each',
  Volume = 'Volume',
  Weight = 'Weight',
}

export const ALLOWED_PACK_UNITS_FOR_CONVERSION = new Set([
  PackUnit.Case,
  PackUnit.Each,
  PackUnit.Pound,
  PackUnit.Piece,
]);

export const PACK_UNIT_TO_UNIT_TYPE_MAP: Partial<Record<PackUnit, UnitType>> = {
  [PackUnit.Case]: UnitType.Each,
  [PackUnit.Each]: UnitType.Each,
  [PackUnit.Pound]: UnitType.Weight,
  [PackUnit.Piece]: UnitType.Each,
  [PackUnit.Gallon]: UnitType.Volume,
};

export const PORTION_UNIT_TO_UNIT_TYPE_MAP: Record<PortionUnit, UnitType> = {
  [PortionUnit.Cup]: UnitType.Volume,
  [PortionUnit.Each]: UnitType.Each,
  [PortionUnit.FluidOunce]: UnitType.Volume,
  [PortionUnit.Gallon]: UnitType.Volume,
  [PortionUnit.Gram]: UnitType.Weight,
  [PortionUnit.Liter]: UnitType.Volume,
  [PortionUnit.Milliliter]: UnitType.Volume,
  [PortionUnit.Ounce]: UnitType.Weight,
  [PortionUnit.Pint]: UnitType.Volume,
  [PortionUnit.Pound]: UnitType.Weight,
  [PortionUnit.Quart]: UnitType.Volume,
  [PortionUnit.Tablespoon]: UnitType.Volume,
  [PortionUnit.Teaspoon]: UnitType.Volume,
};

export const UNIT_TYPE_TO_PORTION_UNIT_MAP: Record<UnitType, PortionUnit[]> = {
  [UnitType.Each]: [PortionUnit.Each],
  [UnitType.Volume]: [
    PortionUnit.Cup,
    PortionUnit.Pint,
    PortionUnit.Quart,
    PortionUnit.FluidOunce,
    PortionUnit.Tablespoon,
    PortionUnit.Teaspoon,
    PortionUnit.Gallon,
    PortionUnit.Milliliter,
    PortionUnit.Liter,
  ],
  [UnitType.Weight]: [PortionUnit.Pound, PortionUnit.Ounce, PortionUnit.Gram],
};

export const STANDARD_WEIGHT_UNIT_CONVERSION_MAP = {
  [PortionUnit.Gram]: 1 / 453.59237,
  [PortionUnit.Ounce]: 1 / 16,
  [PortionUnit.Pound]: 1,
};

export const STANDARD_VOLUME_UNIT_CONVERSION_MAP = {
  [PortionUnit.Cup]: 1,
  [PortionUnit.FluidOunce]: 0.125,
  [PortionUnit.Gallon]: 16,
  [PortionUnit.Liter]: 4.22675,
  [PortionUnit.Pint]: 2,
  [PortionUnit.Milliliter]: 0.00422675,
  [PortionUnit.Quart]: 4,
  [PortionUnit.Tablespoon]: 0.0625,
  [PortionUnit.Teaspoon]: 1 / 48,
};
